<template>
  <div>
    <template v-if="hasTriggers">
      <template v-for="({ uniqueKey, timers }, qKey) in parsedDependencyList">
        <div
          :key="qKey"
          @click="$EventBus.$emit('selectQuestion', qKey)"
          class="mb-5 p-5 triggered-by bg-info"
        >
          <small>
            This {{ displayType.toLowerCase() }} is triggered by
            <span class="clickable">{{ uniqueKey }}</span>
            <template v-if="timers.length">
              <span class="fas fa-clock pl-5"></span>
              <template v-for="(timer, i) in timers">
                {{ timer | formatTime }}{{ i !== timers.length - 1 ? ',' : null }}
              </template>
              {{ timers.length > 1 ? 'delays' : 'delay' }}
            </template>
          </small>
        </div>
      </template>
    </template>
    <template v-else>
      <div class="mb-5 p-5 triggered-by bg-info text-center">
        <small>
          This {{ displayType.toLowerCase() }} is scheduled at the start of the inbox
          <template v-if="timer">
            with a
            <span class="fas fa-clock"></span>
            {{ timer | formatTime }} delay
          </template>
        </small>
      </div>
    </template>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    props: ['dependencies', 'displayTypeKey', 'timer'],

    computed: {
      ...mapState('editMode/questions', ['questions']),

      hasTriggers() {
        return !!Object.keys(this.dependencies).length;
      },

      displayType() {
        return this.displayTypeKey === 2 ? 'Instant Message' : 'Email';
      },

      // TODO: think of a better way to grab the dependency list, aggregated by the corresponding question keys
      parsedDependencyList() {
        return Object.values(this.dependencies).reduce(
          (acc, { timer, FK_answerKey: answerDependencyKey }) => {
            const { questionKey, uniqueKey } = Object.values(this.questions).find(
              (q) => answerDependencyKey in q.answers
            );

            if (!(questionKey in acc))
              acc[questionKey] = {
                timers: [],
                uniqueKey,
              };
            if (timer > 0) {
              acc[questionKey].timers.push(timer);
            }
            return acc;
          },
          {}
        );
      },
    },
  };
</script>

<style lang="scss" scoped>
  .clickable {
    text-decoration: underline;
    cursor: pointer;
    color: #0073ad !important;
  }
  .triggered-by {
    margin-bottom: 5px;
    display: block;
    border-radius: 2px;
  }
</style>
